
export const excel_info = 'Microsoft Excel is a powerful spreadsheet application included in the Microsoft 365 suite that is used for data organization, analysis, and visualization. '

export const excel_md = `
# Microsoft Excel  
*Last updated on July 14, 2025*

## Overview

Microsoft Excel is a powerful spreadsheet application included in the Microsoft 365 suite that is used for data organization, analysis, and visualization. 
It allows you to work with numbers, formulas, charts, pivot tables, and more.

## Benefits
- **Advanced Data Analysis Tools**: including formulas, functions, and pivot tables
- **Data Visualization**: Chart creation for visualizing trends and insights
- **Collaboration**: Collaboration features for real-time editing and commenting with multiple users
- **Integration**: Seamless integration with other Microsoft 365 apps like Outlook and OneDrive.
- **Compatibility**: Support for importing/exporting data from various sources (CSV, databases, etc.)

## Requirements
- A user account with us
- A valid Microsoft 365 subscription
- An up to date version of Windows

## Getting Started
- Excel gets installed as part of the [Microsoft 365](https://it.bockwaterheaters.com/#/services/m365) suite.

For online access, go to [https://m365.cloud.microsoft/apps/](https://m365.cloud.microsoft/apps/), sign in, and then click on the Excel icon.

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)

`